/* istanbul ignore file */
import { Dropdown } from 'framework/form';
import React from 'react';
import { CandidateApplicationSourceType } from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';

const CandidateApplicationSourceTypeDropdown = (props: any) => {
  return (
    <Dropdown
      placeholder="Choose Candidate Application Source Name"
      options={Object.values(CandidateApplicationSourceType).map(value => ({
        value,
        label: value,
      }))}
      label="Candidate application source type"
      {...props}
    />
  );
};

export default CandidateApplicationSourceTypeDropdown;
